import { scaleSymlog } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updateSymlogScale = scaleOperator('domain', 'range', 'reverse', 'clamp', 'constant', 'nice', 'zero', 'round');
export default function createSymlogScale(config) {
  return updateSymlogScale(scaleSymlog(), config);
}